import React from 'react'
import { Card, Flex, Text } from '@tremor/react'
import { Target, Phone, Star, Clock, Flame } from '@/components/icons'
import { cn } from '@/lib/utils'

const goals = [
  {
    icon: Target,
    text: '55% team conversion target',
    highlight: true,
    color: 'text-violet-500',
    bgColor: 'bg-violet-100',
  },
  {
    icon: Phone,
    text: 'Keep missed calls <15/month',
    color: 'text-red-500',
    bgColor: 'bg-red-100',
  },
  {
    icon: Star,
    text: 'Quality score 80+',
    color: 'text-amber-500',
    bgColor: 'bg-amber-100',
  },
  {
    icon: Clock,
    text: 'Peak hours: 10 AM - 2 PM',
    color: 'text-blue-500',
    bgColor: 'bg-blue-100',
  },
]

export function TeamFocus() {
  return (
    <Card className="border-0 shadow-industrial border-l-4 border-l-amber-500 bg-gradient-to-r from-amber-50/50 to-white animate-fade-in">
      {/* Header */}
      <Flex alignItems="center" className="gap-3 mb-4">
        <div className="p-2 rounded-lg bg-amber-100 text-amber-600">
          <Target className="w-5 h-5" />
        </div>
        <Text className="text-zinc-950 font-semibold text-lg">
          Team Focus Today
        </Text>
      </Flex>

      {/* Goals Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {goals.map((goal, index) => {
          const Icon = goal.icon
          return (
            <div
              key={index}
              className={cn(
                "flex items-center gap-3 px-4 py-3 rounded-lg transition-colors",
                goal.highlight
                  ? "bg-violet-50 ring-1 ring-violet-200"
                  : "bg-white hover:bg-zinc-50"
              )}
            >
              <div className={cn(
                "p-1.5 rounded-md",
                goal.bgColor
              )}>
                <Icon className={cn("w-4 h-4", goal.color)} />
              </div>
              <span className={cn(
                "text-sm",
                goal.highlight ? "font-medium text-zinc-900" : "text-zinc-700"
              )}>
                {goal.text}
              </span>
            </div>
          )
        })}
      </div>

      {/* Motivational Banner */}
      <div className="mt-4 p-4 bg-gradient-to-r from-zinc-900 to-zinc-800 rounded-lg">
        <Flex alignItems="center" justifyContent="center" className="gap-2">
          <Flame className="w-5 h-5 text-amber-400" />
          <span className="text-white font-bold uppercase tracking-wide text-sm">
            CONSISTENT QUALITY = MAX EARNINGS
          </span>
          <Flame className="w-5 h-5 text-amber-400" />
        </Flex>
      </div>
    </Card>
  )
}
